import {EntityModel} from "@fedeltapointofsale/data-client";
import {PositionData} from "./position.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PositionEntityModel extends EntityModel<PositionData> {

    constructor(injector: Injector) {
        super(injector, PositionData)
    }
}
